module.exports = __webpack_public_path__ + "img/layout.e72f2c27.jpg";